import OneNewsView from '@/components/views/OneNewsView'
import { setSocialImage } from '@/redux/meta/slice'
import { wrapper } from '@/redux/store'
import NewsService from '@/services/news.service'
import { INews } from '@/types/news.interface'
import { makeStaticProps } from '@/utils/helpers/make-static-props.helper'
import { GetStaticPaths, GetStaticProps, NextPage } from 'next'

interface Props {
  news?: INews
}

const NewsByIdPage: NextPage<Props> = ({ news }) => {
  if (!news) return null

  return <OneNewsView news={news} />
}

export default NewsByIdPage
export const getStaticPaths: GetStaticPaths = async () => {
  const newsIds = await NewsService.getAllIds()
  return {
    paths: newsIds.map((id) => ({ params: { oldId: id.toString() } })),
    fallback: false,
  }
}
export const getStaticProps: GetStaticProps<Props> = wrapper.getStaticProps((store) =>
  makeStaticProps(store, undefined, [], async (context) => {
    const oldId = context?.params?.oldId || 0
    const news = await NewsService.getNewsById(Number(oldId))

    const socialImage = news?.imageUrl || news?.body.match(/src="([^"]+)"/)?.[1]
    if (socialImage) {
      store.dispatch(setSocialImage(socialImage))
    } else {
      store.dispatch(setSocialImage(null))
    }

    return {
      props: { news },
    }
  })
)
